<div class="container-fluid environment-selection-container">
    <!-- Custom Loader (matches ngx-ui-loader) -->
    <div class="custom-loader-overlay" *ngIf="showLoader">
        <div class="custom-loader-wrapper">
            <div class="relative">
                <img class="face-loader" src="/../../assets/images/face-gif-unscreen.gif" alt="Login image" width="47">
                <img src="/../../assets/images/Circle-Loader.gif" alt="Login image" width="96">
            </div>
        </div>
    </div>

    <!-- Back Button -->
    <button class="back-button" (click)="goBack()" mat-icon-button aria-label="Go back">
        <mat-icon>arrow_back</mat-icon>
    </button>

    <div class="environment-selection-wrapper">
        <!-- Logo Section -->
        <div class="logo-section">
            <div class="logo-container">
                <div class="logo-icon">
                    <img src="assets/images/wize-logo.png" alt="Wize Logo" class="owl-icon" />
                </div>
            </div>
        </div>

        <!-- Welcome Text -->
        <div class="welcome-section">
            <h1 class="welcome-title">Welcome back, Select which environment you would like to use</h1>
            <p class="welcome-description">
                With Wizefulfill profiles, you can manage your accounts easily <br> and create multiple profiles easily.
            </p>
        </div>

        <!-- Environments Grid -->
        <div class="environments-content">
            <div class="environments-grid" *ngIf="!isLoading">
                <!-- Existing Environments -->
                <div *ngFor="let environment of environments" class="environment-card"
                    (mouseenter)="onEnvironmentHover(environment.id)" (mouseleave)="onEnvironmentHover(null)"
                    (click)="onEnvironmentClick(environment)" [class.hovered]="hoveredEnvironmentId === environment.id">
                    <div class="environment-avatar">
                        <div class="avatar-circle" [style.background-color]="getAvatarColor(environment)">
                            <!-- <span *ngIf="!environment.avatar" class="avatar-initials">
                                {{ getInitials(environment?.account_title || '') }}
                            </span> -->
                             <img
                                *ngIf="!environment?.avatar"
                                [src]="
                                environment?.user_role_name === 'System Administrator'
                                    ? '/assets/images/admin_role_icon.svg'
                                    : '/assets/images/multi_role_icon.svg'
                                "
                                [alt]="environment?.user_role_name || ''"
                                class="avatar-image"
                            />
                            <img *ngIf="environment.avatar" [src]="environment.avatar"
                                [alt]="environment?.account_title || ''" />
                        </div>
                    </div>
                    <div class="environment-info">
                        <h3 class="environment-name">{{ environment?.account_title || '' }}</h3>
                        <h3 class="environment-company-name" *ngIf="environment?.company_name">
                        {{ environment.company_name | uppercase }}
                        </h3>
                        <p
                            class="environment-type"
                            *ngIf="environment?.user_role_name"
                            [ngClass]="{
                                'primary-role': environment?.user_role_name !== 'System Administrator'
                            }"
                            >
                            {{ environment.user_role_name }}
                        </p>
                    </div>
                </div>
            </div>

            <!-- Loading State -->
            <div class="loading-container" *ngIf="isLoading">
                <div class="spinner"></div>
                <!-- <p>Loading environments...</p> -->
            </div>
        </div>
    </div>
</div>
